import { RouteRecordRaw } from 'vue-router'

const needToBeDealtWith: Array<RouteRecordRaw> = [
    {
        path: '/needToBeDealtWith',
        name: 'needToBeDealtWith',
        redirect: '/needToBeDealtWith/issueOperation',
        component: () => import('@/views/children.vue'),
        children: [
            {
                path: '/needToBeDealtWith/issueOperation',
                name: 'issueOperation',
                meta: {
                    title: '出库操作',
                    keepAlive: false
                },
                component: () => import('@/views/needToBeDealtWith/exWarehouse.vue')
            },
            {
                path: '/needToBeDealtWith/warehousing',
                name: 'warehousing',
                meta: {
                    title: '入库操作',
                    keepAlive: false
                },
                component: () => import('@/views/needToBeDealtWith/warehousing.vue')
            },
            {
                path: '/needToBeDealtWith/outbound',
                name: 'outbound',
                meta: {
                    title: '新增出库',
                    keepAlive: false
                },
                component: () => import('@/views/needToBeDealtWith/outbound.vue')
            },
            {
                path: '/needToBeDealtWith/addWarehousing',
                name: 'addWarehousing',
                meta: {
                    title: '新增入库',
                    keepAlive: false
                },
                component: () => import('@/views/needToBeDealtWith/addWarehousing.vue')
            },
            {
                path: '/needToBeDealtWith/codeScanningWarehousing',
                name: 'codeScanningWarehousing',
                meta: {
                    title: '扫码入库',
                    keepAlive: false
                },
                component: () => import('@/views/needToBeDealtWith/codeScanningWarehousing.vue')
            },
            {
                path: '/needToBeDealtWith/adjustReceipt',
                name: 'adjustReceipt',
                meta: {
                    title: '调整入库',
                    keepAlive: false
                },
                component: () => import('@/views/needToBeDealtWith/adjustReceipt.vue')
            },
            {
                path: '/needToBeDealtWith/transfer',
                name: 'transfer',
                meta: {
                    title: '新建转库',
                    keepAlive: false
                },
                component: () => import('@/views/needToBeDealtWith/transfer.vue')
            },
            {
                path: '/needToBeDealtWith/scanning',
                name: 'scanning',
                meta: {
                    title: '扫码转库',
                    keepAlive: false
                },
                component: () => import('@/views/needToBeDealtWith/scanning.vue')
            }
        ]
    }
]

export default needToBeDealtWith
